import React, { useState } from 'react';
import { PatternFormat } from 'react-number-format';
import styles from './form-input.module.scss';
import { IFormInputProps } from './form-input.interface';
import { normalizePhone } from 'shared/lib';
import { EyeOpenSvg, EyeClosedSvg } from 'shared/svg';

export const FormInput: React.FC<IFormInputProps> = ({
  inputValue,
  inputTitle = 'Заголовок',
  inputPlaceholder = 'Пример',
  inputType = 'text',
  isPhone = false,
  showPasswordToggle = false,
  onChange,
  ...props
}) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const handleTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) onChange(e.target.value);
  };

  const handlePhoneChange = (values: { value: string }) => {
    if (onChange) {
      onChange(normalizePhone(values.value));
    }
  };

  const handlePhonePaste = (e: React.ClipboardEvent) => {
    const pasted = e.clipboardData.getData('text');
    const digits = pasted.replace(/\D/g, '');
    if (digits.length > 10 && onChange) {
      e.preventDefault();
      onChange(normalizePhone(digits));
    }
  };
  const displayValue =
    isPhone && inputValue?.startsWith('7') ? inputValue.slice(1) : inputValue;

  const resolvedType =
    showPasswordToggle && isPasswordVisible ? 'text' : inputType;

  return (
    <div className={styles.form_input}>
      <div className={styles.form_input__title}>{inputTitle}</div>

      {isPhone ? (
        <PatternFormat
          {...props}
          format="+7 (###) ###-##-##"
          mask="_"
          className={styles.form_input__input}
          data-cy="phone"
          placeholder="+7 (999) 999-99-99"
          allowEmptyFormatting
          onValueChange={handlePhoneChange}
          onPaste={handlePhonePaste}
          value={displayValue}
        />
      ) : (
        <div className={styles.input_wrapper}>
          <input
            {...props}
            value={inputValue}
            className={styles.form_input__input}
            type={resolvedType}
            placeholder={inputPlaceholder}
            onChange={handleTextChange}
            style={showPasswordToggle ? { paddingRight: '40px' } : undefined}
          />
          {showPasswordToggle && (
            <button
              type="button"
              className={styles.eye_button}
              onClick={() => setIsPasswordVisible((v) => !v)}
              tabIndex={-1}
            >
              {isPasswordVisible ? <EyeOpenSvg /> : <EyeClosedSvg />}
            </button>
          )}
        </div>
      )}
    </div>
  );
};
